export const getPlanTypeText = (unique_plan_types: (string | null)[][]) => {
  let textStr = '';

  for (let i = 0; i < unique_plan_types.length; i += 1) {
    const typeArr = unique_plan_types[i];

    if (typeArr[0] === 'One Time Purchase') {
      textStr += 'Lifetime deal';
    } else if (typeArr[0] === 'Limited License') {
      textStr += `${typeArr[2]} ${typeArr[1]} DEAL`;
    } else {
      textStr += typeArr[0];
    }

    if (i < unique_plan_types.length - 1) {
      textStr += ' & ';
    }
  }

  return textStr;
};
